import { useMemo } from 'react';
import * as THREE from 'three';

const WireframeShader = ({ 
  geometry, 
  position, 
  rotation, 
  scale, 
  wireframeThickness = 1.0, 
  wireframeColor = [0.05, 0.05, 0.05],
  ...props 
}) => {
  // Create multiple wireframe meshes with slight offsets for thickness effect
  const wireframeMeshes = useMemo(() => {
    if (!geometry) return [];

    const meshes = [];
    const color = new THREE.Color().fromArray(wireframeColor);
    
    // Create multiple wireframe layers for thickness
    const layers = Math.max(1, Math.floor(wireframeThickness * 2));
    
    for (let i = 0; i < layers; i++) {
      const material = new THREE.MeshBasicMaterial({
        color: color,
        wireframe: true,
        transparent: true,
        opacity: 1.0 / layers, // Distribute opacity across layers
        depthTest: true,
        depthWrite: false,
        polygonOffset: true,
        polygonOffsetFactor: -1 - i * 0.1,
        polygonOffsetUnits: -1 - i * 0.1
      });

      // Slightly offset each layer for thickness effect
      const offset = (i - layers / 2) * 0.0001 * wireframeThickness;
      const layerScale = [
        ...scale.map(s => s * (1.001 + offset))
      ];

      meshes.push({
        key: `wireframe-layer-${i}`,
        material,
        scale: layerScale
      });
    }

    return meshes;
  }, [geometry, wireframeThickness, wireframeColor, scale]);

  if (!wireframeMeshes.length) return null;

  return (
    <>
      {wireframeMeshes.map(({ key, material, scale: layerScale }) => (
        <mesh
          key={key}
          geometry={geometry}
          material={material}
          position={position}
          rotation={rotation}
          scale={layerScale}
          {...props}
        />
      ))}
    </>
  );
};

export default WireframeShader;
